import { useMemo } from 'react'

import {
  GlobalDrawerProvider,
  IrisProvider
} from '@arcotech-services/iris-react'

import createLinkAdapter from '../../components/LinkAdapter'
import type { LayoutProviderProps } from './layout-provider.types'

const LayoutProvider: React.FC<LayoutProviderProps> = ({ children }) => {
  const linkComponent = useMemo(() => createLinkAdapter(), [])

  return (
    <IrisProvider linkComponent={linkComponent}>
      <GlobalDrawerProvider>{children}</GlobalDrawerProvider>
    </IrisProvider>
  )
}

export default LayoutProvider
